module.exports = __webpack_public_path__ + "static/media/winter.89c3ea17.jpeg";